import { NeoModel, Validation, ValueObject } from "@singularsystems/neo-core";
import { TextConstants } from "../../../../Common/TextConstants";

@NeoModel
export default class UpdateExportColumnSpecCommand extends ValueObject {
    public staticExportColumnSpecId: number = 0;
    
    public staticExportFileSpecId: number = 0;

    public fieldName: string = "";

    public description: string = "";

    public dataType: string = "";

    public displayFormat: string | null = "";

    public columnNumber: number = 0;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(d => d.dataType === "Datetime" && (d.displayFormat === undefined || d.displayFormat === ""), TextConstants.Validation.MissingDateFormat);
    }
}